// pages/Dashboard.js
import React, { useState } from 'react';
import { Layout, Menu, Button, Drawer } from 'antd';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { dashboardRoutes } from '../routes';
import LogoutButton from '../components/LogoutButton';
import { MenuOutlined } from '@ant-design/icons';

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const location = useLocation();
  const selectedKey = `/dashboard/${location.pathname.split('/')[2] || 'home'}`;

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // هندل resize برای موبایل / دسکتاپ
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ساخت آیتم‌های منو از روی dashboardRoutes
  const menuItems = dashboardRoutes
    .filter(r => r.label) // فقط مسیرهایی که label دارند
    .map(r => ({
      key: `/dashboard/${r.path}`,
      icon: r.icon,
      label: <Link to={`/dashboard/${r.path}`}>{r.label}</Link>,
    }));

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* سایدبار دسکتاپ */}
      {!isMobile && (
        <Sider collapsible className="desktop-sidebar">
          <div
            style={{
              color: 'white',
              textAlign: 'center',
              padding: '16px',
              fontWeight: 'bold',
            }}
          >
            پنل ادمین
          </div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
          />
        </Sider>
      )}

      {/* محتوای اصلی */}
      <Layout>
        <Header
          style={{
            background: '#fff',
            padding: '0 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
          }}
        >
          {/* سمت چپ (برند + همبرگر موبایل) */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined style={{ fontSize: 20 }} />}
                onClick={() => setDrawerVisible(true)}
              />
            )}
            <div style={{ fontWeight: 700, fontSize: 16 }}>پنل ادمین</div>
          </div>

          {/* سمت راست (دکمه خروج) */}
          <div>
            <LogoutButton />
          </div>
        </Header>

        <Content
          style={{
            margin: '16px',
            padding: '16px',
            backgroundColor: '#fff',
            minHeight: 280,
          }}
        >
          <Routes>
            {dashboardRoutes.map(r => (
              <Route key={r.path} path={r.path} element={r.element} />
            ))}
          </Routes>
        </Content>
      </Layout>

      {/* منوی موبایل */}
      {isMobile && (
        <Drawer
          title="منو"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            onClick={() => setDrawerVisible(false)}
          />
        </Drawer>
      )}
    </Layout>
  );
};

export default Dashboard;
